import { Grid } from 'semantic-ui-react';
import styled from 'styled-components';

export const FormTermsWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap !important;
  .segment {
    margin: 0px !important;
    padding: 0px !important;
  }
`;

export const FormTermsAndPrivacy = styled.a`
cursor: pointer;
display: block;
white-space: nowrap;
text-overflow: ellipsis;
overflow: hidden;
&:hover {
  opacity: 0.7;
}

.ui.loading.segment::before {
background: none !important;
font-size: 5px !important;
}
`;

export const StyledGrid = styled(Grid)`
 padding: 15px !important;
 .column-value {
  font-weight: bold !important;
 }
`
export const SchedulerRow = styled(Grid.Row)`
align-items: end !important;
`